import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import DevTools from './shared/config/devtools';
import initStore from './shared/config/store';
import { registerLocale } from './shared/config/translation';
import AppComponent from './app';
import { loadIcons } from './shared/config/icon-loader';
import { ErrorGlobalBoundary } from './shared/error/error-global-boundary';
import { globalDebug } from './shared/util/method-util';

const devTools = process.env.NODE_ENV === 'development' ? <DevTools /> : null;

const store = initStore();
registerLocale(store);

globalDebug();

loadIcons();

const rootEl = document.getElementById('root');

const render = Component =>
  // eslint-disable-next-line react/no-render-return-value
  ReactDOM.render(
    <ErrorGlobalBoundary>
      <Provider store={store}>
        <div>
          {/* If this slows down the app in dev disable it and enable when required  */}
          {devTools}
          <Component />
        </div>
      </Provider>
    </ErrorGlobalBoundary>,
    rootEl
  );

render(AppComponent);
